import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import axios, { AxiosResponse, AxiosError } from 'axios';
import {
    STORE_PAYMENT_DATA,
    PaymentData,
    InvoiceData,
    STORE_PROGRESS_ISWAITING,
    STORE_PAYMENT_ID,
    STORE_RETURN_TRANSACTION_ID,
    STORE_RETURN_TRANSACTION_STATUS,
    STORE_RETURN_TRANSACTION_STATUS_DESC,
    STORE_RETURN_TRANSACTION_TXN_AMT,
    STORE_RETURN_TRANSACTION_PAY_U_ID,
    STORE_RETURN_TRANSACTION_AXPERROR,
    STORE_P_STARTDATE,
    STORE_P_ENDDATE
} from 'src/reducers/payment';
import {
    STORE_ERROR_FILES_UPLOADED_MSG,
    STORE_ERROR_FILES_UPLOADED
} from 'src/reducers/errors';
import { push } from 'react-router-redux';

interface Payparam {
    frDt: string | null;
    toDt: string | null;
}

export const commonDateFormat = (actualDate: Date | null, type: string) => {

    if (actualDate === null) {
        return null;
    }

    const date = typeof (actualDate) === 'object' ? actualDate : new Date(actualDate);

    if (type === 'date' && date !== null) {

        const year = date.getFullYear();
        const month = `0${date.getMonth() + 1}`.slice(-2);
        const day = `0${date.getDate()}`.slice(-2);
        const final = [day, month, year].join('/');

        return final;
    } else if (type === 'time' && date !== null) {

        const hours = `0${date.getHours()}`.slice(-2);
        const minutes = `0${date.getMinutes()}`.slice(-2);
        const seconds = `0${date.getSeconds()}`.slice(-2);
        const strTime = `${hours}:${minutes}:${seconds}`;

        return strTime;
    }
    return null;

};

export const getUserPaymentData = (getDate: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const sessionid = getState().user.userDetails.s || '';

        const returnTransactionId: string = '';
        const returnTransactionStatus: boolean = false;
        const paymentStatus: string = '';
        const txnid: string = '';
        const txnamt: string = '';
        const axperror: string = '';

        dispatch({ type: STORE_RETURN_TRANSACTION_ID, returnTransactionId } as AnyAction);
        dispatch({ type: STORE_RETURN_TRANSACTION_STATUS, returnTransactionStatus } as AnyAction);
        dispatch({ type: STORE_RETURN_TRANSACTION_STATUS_DESC, paymentStatus } as AnyAction);
        dispatch({ type: STORE_RETURN_TRANSACTION_PAY_U_ID, txnid } as AnyAction);
        dispatch({ type: STORE_RETURN_TRANSACTION_TXN_AMT, txnamt } as AnyAction);
        dispatch({ type: STORE_RETURN_TRANSACTION_STATUS, axperror } as AnyAction);

        const dataParam: Payparam = {
            frDt: '',
            toDt: ''
        };

        if (getDate === 'get') {

            dataParam.frDt = commonDateFormat(getState().payment.startPDate || null, 'date') || null;
            dataParam.toDt = commonDateFormat(getState().payment.endPDate || null, 'date') || null;

        } else if (getDate === 'reset') {

            dataParam.frDt = commonDateFormat(null, 'date') || null;
            dataParam.toDt = commonDateFormat(null, 'date') || null;

            const startPDate = null;
            const endPDate = null;

            dispatch({ type: STORE_P_STARTDATE, startPDate } as AnyAction);
            dispatch({ type: STORE_P_ENDDATE, endPDate } as AnyAction);

        }

        await axios({
            method: 'post',
            url: `${getState().environment.API_URL}getOpenInvoices?userId=${getState().user.userDetails.labCode}`,
            data: dataParam,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                sessionid: sessionid || ''
            }
        }).then(async function (response: AxiosResponse) {
            if (response.data.length === 1) {
                if (response.data[0].invoiceno !== '') {
                    const getPaymentData: PaymentData[] = response.data;
                    dispatch({ type: STORE_PAYMENT_DATA, getPaymentData } as AnyAction);
                } else {
                    const getPaymentData: PaymentData[] = [];
                    dispatch({ type: STORE_PAYMENT_DATA, getPaymentData } as AnyAction);
                }
            } else {
                const getPaymentData: PaymentData[] = response.data;
                dispatch({ type: STORE_PAYMENT_DATA, getPaymentData } as AnyAction);
            }

        }).catch(function (error: AxiosError) {
            // ==> console.error(error);
        });
    };
};

// export const totalAmount = (amount: number) => {
//     return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//         const paymentAmount = amount;
//         dispatch({ type: STORE_PAYMENT_AMOUNT, paymentAmount } as AnyAction);
//     };
// };
// export const totalUnits = (units: number) => {
//     return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//         const unitTotal = units;
//         dispatch({ type: STORE_PAYMENT_UNITS, unitTotal } as AnyAction);
//     };
// };
export const postPaymentDetails = (total: number, tableData: PaymentData[] | PaymentData) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const invoiceData: Array<InvoiceData> = [];
        const sessionid = getState().user.userDetails.s || '';

        let isWaiting = true;
        dispatch({ type: STORE_PROGRESS_ISWAITING, isWaiting } as AnyAction);

        if (Array.isArray(tableData) && tableData.length > 0) {
            tableData.map((arr, index) => {
                invoiceData.push({
                    invoiceno: arr.invoiceno,
                    settledamt: arr.invamount
                });
            });
        }
        const details = {
            column: {
                refno: '13468436',
                custcode: getState().user.userDetails.labCode,
                payamount: total.toString()
            },
            columns: invoiceData
        };

        axios({
            method: 'post',
            url: `${getState().environment.API_URL}initiatePayment`,
            data: details,
            headers: {
                sessionid: sessionid || ''
            },
        }).then(async function (response: AxiosResponse) {
            // // ==> console.error(response.data.ID);

            if (response.data.ID) {
                const paymentId = response.data.ID;
                dispatch({ type: STORE_PAYMENT_ID, paymentId } as AnyAction);
                isWaiting = false;
                dispatch({ type: STORE_PROGRESS_ISWAITING, isWaiting } as AnyAction);
                // // ==> console.error(isWaiting, 'second');
            }

        }).catch(function (error: AxiosError) {
            // ==> console.error(error);
        });
    };
};

export const isWaitingClear = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const isWaiting = false;
    dispatch({ type: STORE_PROGRESS_ISWAITING, isWaiting } as AnyAction);
};

export const createInputElementPay = (formelementPay: HTMLElement, responseData: object) => {

    const keyPair = Object.keys(responseData);

    // Object.entries(responseData).map((eachData) => {
    //     const element = document.createElement('input');
    //     element.setAttribute('type', 'hidden');
    //     element.setAttribute('name', eachData[0]);
    //     element.setAttribute('value', eachData[1]);
    //     formelementPay.appendChild(element);
    // });

    keyPair.map((keys, index) => {
        const element = document.createElement('input');
        element.setAttribute('type', 'hidden');
        element.setAttribute('name', keys);
        element.setAttribute('value', responseData[keyPair[index]]);
        formelementPay.appendChild(element);
    });

    return formelementPay;
};

export const checkoutPayment = (amount: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        const referenceId = getState().payment.paymentId;

        const requestData = {
            'txnId': referenceId,
            'amount': amount,
            'fname': getState().user.username,
            'email': getState().userProfileData.userProfiledata.emailid,
            'phone': parseInt(getState().userProfileData.userProfiledata.phoneno, 10),
            'sessionid': getState().user.userDetails.s
        };

        if (referenceId) {
            axios({
                method: 'post',
                url: `${getState().environment.API_URL}checkoutPayment`,
                data: requestData
            }).then(async function (response: AxiosResponse) {
                if (response.data) {
                    // window.location.href = response.data;
                    const paymentInfo = response.data;
                    const formElement = document.createElement('form');
                    formElement.style.display = 'none';
                    // formElement.target = '_blank';
                    formElement.action = paymentInfo.url;
                    formElement.method = 'POST';
                    // formElement.target = '_blank';
                    formElement.id = 'paymentForm';
                    const valueElement = createInputElementPay(formElement, paymentInfo);

                    document.body.appendChild(valueElement);
                    formElement.submit();

                } else {
                    const errorFileUploadedOpen = true;
                    const errorfilemsg = 'Something went wrong!';
                    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
                    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
                }

            }).catch(function (error: AxiosError) {
                const errorFileUploadedOpen = true;
                const errorfilemsg = 'Something went wrong!';
                dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
                dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            });
        }
    };
};

export const postTransaction = (success: string | null, failed: string | null, paymentStatus: string | null, txnid: string | null, txnamt: string | null, error: string | null) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        let responseFromserver = false;

        let returnTransactionId = '';
        let returnTransactionStatus = false;

        if (success) {
            returnTransactionId = success;
            returnTransactionStatus = true;
            responseFromserver = true;
        }
        if (failed) {
            returnTransactionId = failed;
            returnTransactionStatus = false;
            responseFromserver = true;
        }

        if (!responseFromserver) {
            dispatch(push('/app/home'));

            const errorFileUploadedOpen = true;
            const errorfilemsg = 'Something went wrong!';
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);

            return;
        }

        dispatch({ type: STORE_RETURN_TRANSACTION_ID, returnTransactionId } as AnyAction);
        dispatch({ type: STORE_RETURN_TRANSACTION_STATUS, returnTransactionStatus } as AnyAction);
        dispatch({ type: STORE_RETURN_TRANSACTION_STATUS_DESC, paymentStatus } as AnyAction);
        dispatch({ type: STORE_RETURN_TRANSACTION_PAY_U_ID, txnid } as AnyAction);
        dispatch({ type: STORE_RETURN_TRANSACTION_TXN_AMT, txnamt } as AnyAction);
        let axperror = '';
        if (error !== null) {
            axperror = error;
            dispatch({ type: STORE_RETURN_TRANSACTION_AXPERROR, axperror } as AnyAction);
        } else {
            dispatch({ type: STORE_RETURN_TRANSACTION_AXPERROR, axperror } as AnyAction);
        }

        dispatch(push('/app/paymentstatus'));

        const paymentId = '';
        dispatch({ type: STORE_PAYMENT_ID, paymentId } as AnyAction);
    };
};

export const savePfromDate = (startPDate: Date | null) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_P_STARTDATE, startPDate } as AnyAction);
    };
};

export const savePtoDate = (endPDate: Date | null) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_P_ENDDATE, endPDate } as AnyAction);
    };
};



// WEBPACK FOOTER //
// ./src/actions/paymentAction.ts